import { render, staticRenderFns } from "./sonic-user-charger.vue?vue&type=template&id=196c9ed4"
import script from "./sonic-user-charger.vue?vue&type=script&lang=js"
export * from "./sonic-user-charger.vue?vue&type=script&lang=js"
import style0 from "./sonic-user-charger.vue?vue&type=style&index=0&id=196c9ed4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports